import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { WalletIcon } from "@components/icons/WalletIcon";
import WalletTag from "@components/shared/WalletTag";
import { useRootAppStore } from "@hooks";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { getCurrentCulture, getWalletByShopIdAndAccountTypeId } from "@utils";
import { shouldUseSlipStatusInstead } from "@utils/offer/shouldUseSlipStatusInstead";
import { observer } from "mobx-react";
import FreebetTag from "@components/shared/FreebetTag";

export default observer(function BetStatus() {
	const { t } = useTranslation("mybets");
	const rootStore = useRootAppStore();
	const bet = useContext(MyBetsBetContext);
	const store = useContext(MyBetsStoreContext);
	if (!(store instanceof MyBetsStore)) {
		return null;
	}
	const bettingAccountType = rootStore.userAuthStore.userAccounts?.find(
		(type) => type.accountTypeId === bet.bettingAccountTypeId
	);

	const userAccount = getWalletByShopIdAndAccountTypeId(
		bet.shopId,
		bet.bettingAccountTypeId,
		rootStore.userAuthStore.userAccounts || []
	);

	let betStatus = bet.betStatus;
	let betStatusClass =
		"card--bet__status tag tag--base tag--bet tag--bet--" + betStatus?.abrv;

	if (shouldUseSlipStatusInstead(bet)) {
		betStatus = bet.betSlipStatus;
		betStatusClass =
			"card--bet__status tag tag--base tag--slip tag--slip--" +
			bet.betSlipStatus.abrv;
	}

	return (
		<div className="card--bet__ticket">
			<div className="card--bet__tags">
				<span className={betStatusClass}>
					{betStatus?.name}
					{bet.isLive && (
						<> - {t<string>("ITEM.LIVE_SCORE").toUpperCase()}</>
					)}
					{bet.isBonus && <> ({t<string>("COMMON.BONUS")})</>}
				</span>

				{bet.shouldShowBetSlipStatus && (
					<span
						className={
							"card--bet__status tag tag--base tag--slip tag--slip--" +
							bet.betSlipStatus.abrv
							// + "--inverted"
						}
					>
						{bet.betSlipStatus.name}
					</span>
				)}

				{bet.hasBetBuilder && (
					<span
						className={
							"card--bet__status tag tag--base tag--bet tag--bb tag--bb--grow"
						}
					>
						Bet Builder
					</span>
				)}

                <FreebetTag isFreebet={bet.isFreebet} />

				<WalletTag
					isWalletManuallyDisabled={
						bet.isWalletManuallyDisabled || false
					}
				/>

				<WalletIcon
					bettingAccountTypeAbrv={bettingAccountType?.abrv || ""}
					iconSize="u-icon--sml"
					classList="u-mar--right--reset u-mar--left--reset"
					isWalletManuallyDisabled={
						bet.isWalletManuallyDisabled || false
					}
				/>
			</div>

			<div className="card--bet__number">
				<Link
					to={`/${getCurrentCulture()}/my-bets/details/${bet.id}/${userAccount?.id || bettingAccountType?.id}`}
					className="u-anchor"
                    >
					{t<string>(
                        "ACC_STATEMENT.BET_DETAILS.BET_SLIP_NUMBER_SINGLE",
						{
                            0: bet.betSlipNumber,
						}
					)}
				</Link>
			</div>
		</div>
	);
});
